/**
 * Live event countdowns. Any element with `.countdown[data-date="YYYY-MM-DD"]`
 * gets its day count filled in, e.g. "14 päivää tapahtumaan".
 */
export function initCountdowns() {
	const nodes = document.querySelectorAll('.countdown[data-date]');
	if (!nodes.length) return;

	const today = new Date();
	today.setHours(0, 0, 0, 0);

	nodes.forEach((el) => {
		const target = new Date(`${el.dataset.date}T00:00:00`);
		const days = Math.max(0, Math.round((target - today) / 86400000));
		const b = el.querySelector('b');
		const small = el.querySelector('small');
		if (b) b.textContent = days;
		if (small) small.textContent = days === 1 ? 'päivä' : 'päivää';
		if (days <= 14) el.classList.add('soon');
	});
}
